export const ProjectIconsOptionsList : string[][]  = [

//Double usage in old version!!!!!!!!!!:
// Sprint (view-gantt), Kanban (view-board), Tasks (view-list), Calendar (view-calendar), assets (view-portfolio),



    //Project Management
    [
        'folder',
        'project',
        'dev',
        'backlog',
        'requests',
        'group',
        'tag',
        'workspace',
        'briefcase',
        'view-projects-list',
        'view-portfolio',



    ],


    //Views
    [
        'view',
        'view-list',
        'view-table',
        'view-board',
        'view-calendar',
        'view-events-summary',
        'event',
        'view-expenses',
        'scrum',
        'view-gantt',
        'view-workload',
        'view-activity',
        'view-what-is-done',
        'view-pastdue',
        'view-priorities',
        'view-action-required',
        'view-tasks-by-user',
        'view-dashboard',
        'report'
    ],


    //Development & Technology
    [
        'mobile',
        'desktop',
        'globe',
        'cloud',
        'upload',
        'download',
        'server',
        'database',
        'key',
        'api',
        'qa',
        'bug',
        'idea',
        'rocket',
        'microchip',
        'embed',
        'lightning',
        'network',
        'graph',
    ],


    //Collaboration & Communication
    [
        'support',
        'megaphone',
        'contact',
        'leads',
        'mail_black',
        'mail_read',
        'userSearch',
        'social_broadcast',
        'target',
        'aim',
        'mention',
        'quote',
        'social_rss',
        'search',
        'resources',
        'request',
        'request2',
        'link',
    ],

    //Communication??
    // [
    //     'support',
    //     'megaphone',
    //     'mail_black',
    //     'mail_read',
    //     'request',
    //     'request2',
    //     'quote',
    //     'mention',
    // ],


    //Documentation
    [
        'files',
        'page',
        'file_contact',
        'file_code',
        'file_audio',
        'file_binary',
        'file_media',
        'file_video',
        'file_archive',
        'file_text',
        'spreadsheet',
        'img',
    ],

    //Financials & e-commerce
    [
        'money',
        'credit_card',
        'inventory',
        'shopping_cart',
        'suitcase',

    ],


    //Education
    [
        'bookmark',
        'book',
        'wiki',
        'education',
        'graduate',
    ],

    //Creativity & Design
    [
        'pencil',
        'paint',
        'paint_roller',
        'brush',

    ],


    //Brands
    [
        'windows',
        'android',
        'apple',
        'figma',
        'googleCalendar',
        'googleDoc',
        'googleMap',
        'googleSheet',
        'googleSlides',
        'twitterX',
        'twitter',
        'facebook',
        'youtube',
        'brand',
    ],

    //Entertainment & Media
    [
        'chess',
        'game_console',
        'music',
        'speaker',
        'microphone',
        'football_ball',
        'flask',
        'beer',
        'birthday_cake',
        'hotel',
        'first_aid',
        'flame',
        'tshirt',
        'wheelchair',
        'flag',
        'squirrel',
        'tools',
        'telescope',
        'home',
        'milestone',
        'geo',
        'watch',
        'law',
        'feather',
        'magic_wand',
        'projection_screen',
        'smile',
        'smile_sad',
        'zzz',
        'burst',
        'life_ring',
        'tachometer',
        'anchor',
        'trophy',


    ]





    //
    //
    //
    // [
    //     'folder',
    //     'project',
    //     'page',
    //     'group',
    //     'tag',
    //     'workspace'
    // ],
    // [
    //     'scrum',
    //     'sprint',
    //     'backlog',
    //     'dev',
    //     'kanban',
    //     'files',
    //     'mobile',
    //     'desktop',
    //     'support',
    //     'requests',
    //     'api',
    //     'qa',
    //     'bug',
    //     'tasks',
    // ],
    // [
    //     'rocket',
    //     'megaphone',
    //     'idea',
    //     'book',
    //
    //     'paint',
    //
    //     'money',
    //     'contact',
    //     'leads',
    //
    //
    //
    //     'calendar',
    //     'cloud',
    //     'home',
    //     'mail_black',
    //     'projection_screen',
    //
    //     'android',
    //     'apple',
    //     'windows',
    //
    //     'education',
    //     'assets',
    //
    //     'event',
    //
    //     'img',
    //     'inventory',
    //     'userSearch',
    //
    //     'target',
    //     'aim',
    //     'request',
    //     'request2',
    //
    //
    // ],
    // [
    //     'link',
    //     'embed',
    //     'twitter',
    //     'facebook',
    //     'figma',
    //     'googleCalendar',
    //     'googleDoc',
    //     'googleMap',
    //     'googleSheet',
    //     'googleSlides',
    //     'twitterX',
    //     'youtube',
    // ],
    //
    //
    // [
    //     'view',
    //     'view-list',
    //     'view-table',
    //     'view-board',
    //     'view-calendar',
    //     'view-events-summary',
    //     'view-expenses',
    //     'view-gantt',
    //     'view-workload',
    //     'view-activity',
    //     'view-what-is-done',
    //     'view-pastdue',
    //     'view-priorities',
    //     'view-action-required',
    //     'view-tasks-by-user',
    //     'view-portfolio',
    //     'view-projects-list',
    //     'view-dashboard',
    // ]
]
